import InfoIcon from "@mui/icons-material/Info";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import { COLUMN_HEADER_IMAGE_URL, TEXT } from "./constants";
import { FileUploadFilterMode } from "./types";

interface InfoAlertProps {
  hideAlert?: boolean;
  mode?: FileUploadFilterMode;
}

export const InfoAlert: React.FC<InfoAlertProps> = ({
  hideAlert = false,
  mode = FileUploadFilterMode.DEFINE_WHITESPACE_FILTER,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchorEl);

  const handleInfoMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleInfoMouseLeave = () => setAnchorEl(null);

  if (hideAlert) {
    return null;
  }

  let title = TEXT.CUSTOMER_LIST_TITLE;
  let description = TEXT.CUSTOMER_LIST_DESCRIPTION;

  if (mode === FileUploadFilterMode.UPLOAD_ACCOUNT_FILTER) {
    title = TEXT.ACCOUNT_LIST_TITLE;
    description = TEXT.ACCOUNT_LIST_DESCRIPTION;
  }

  return (
    <>
      <Alert
        icon={
          <Box
            aria-owns={isOpen ? "customer-upload-info-popover" : undefined}
            aria-haspopup="true"
            onMouseEnter={handleInfoMouseEnter}
            onMouseLeave={handleInfoMouseLeave}
          >
            <InfoIcon />
          </Box>
        }
        severity="info"
        sx={{ mb: 2 }}
      >
        {title}
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </Alert>

      <Popover
        id="customer-upload-info-popover"
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleInfoMouseLeave}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "bottom", horizontal: "left" }}
        sx={{ mb: 2, pointerEvents: "none" }}
        disableRestoreFocus
      >
        <Box padding={2} maxWidth={360}>
          <img
            alt={TEXT.COLUMN_HEADERS_ALT}
            src={COLUMN_HEADER_IMAGE_URL}
            width={360}
            height={60}
          />
          <Typography
            fontSize={12}
            dangerouslySetInnerHTML={{
              __html: TEXT.UPLOAD_POPOVER_INSTRUCTIONS,
            }}
          />
        </Box>
      </Popover>
    </>
  );
};
